<template>

  <div
    class="login login-signin-on login-3 d-flex flex-row-fluid"
    id="kt_login"
  >
    <div
      class="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat"
      style="background-image: url('/assets/media/bg/bg-3.jpg');"
    >
      <div class="login-form text-center p-7 position-relative overflow-hidden">

       <h3 class="text-primary">{{$t("LOGINREGISTERPROCESSONPUBLIC.ORGANIZATION")}}</h3>
<!--        <p class="lead text-muted font-weight-bold">-->
<!--          {{$t("LOGINREGISTERPROCESSONPUBLIC.PAYOFF") /* #key_loc */}}-->
<!--        </p>-->
        <p class="mt-6 font-weight-bolder">{{$t("ADVAUTHMETHOD.PARTECIPAPROCESSO")}}</p>

        <div class="my-0">
            <img
              :src="(getOrganization.data) ? getOrganization.data.logo1Uri : '/assets/media/bipart/logo-bipart-brand.svg'"
              style="max-height: 160px; max-width: 260px"
              alt="Logo"
            />
        </div>
        <div class="h5 mt-5 py-5 border-top border-top-2 dashed text-primary">{{ getOrganization.data.name }}</div>


        <div class="login-signup">
          <div class="form-group d-flex flex-wrap flex-center">
              <div class="mt-5">
                <b-button v-b-modal.modal-register class="btn btn-lg btn-primary text-uppercase font-weight-bolder">{{$t("REGISTERPRIVATEPROCESS.BCONFERMA")}}</b-button>
                <p class="mt-5"><b-button href="/assets/email/confirm-email.html" target="blank">{{$t("REGISTERPRIVATEPROCESS.HTMLMAIL")}}</b-button></p>
                <b-modal id="modal-register" size="lg" centered hide-header hide-backdrop hide-footer content-class="shadow" ok-only no-stacking>
                    <div class="row mt-10">
                        <div class="col-5 px-10">
                            <img
                                :src="(getOrganization.data) ? getOrganization.data.logo1Uri : '/assets/media/bipart/logo-bipart-brand.svg'"
                                class="h-60px"
                                alt="Logo"
                            />
                            <div class="mt-5">
                                <h1>{{$t("REGISTERPRIVATEPROCESS.TITOLO")}}</h1>
<!--                                <div class="text-muted font-weight-bold">-->
<!--                                  <p class="lead"> {{$t("REGISTERPRIVATEPROCESS.SOTTOTITOLO") /* #key_loc*/}}</p>-->
<!--                                </div>-->
                                <h2 class="mt-10 text-primary">{{$t("REGISTERPRIVATEPROCESS.PARTECIPAPROCESSO")}}</h2>
                                <p>{{$t("REGISTERPRIVATEPROCESS.PROPOSTE")}}</p>
                            </div>
                            <img
                                src="/assets/media/bipart/ico-patti.png"
                                class="w-100"
                                alt="Logo"
                            />
                        </div>
                        <div class="col-7 border-left px-10">
                            <h2 class="text-primary">{{$t("REGISTERPRIVATEPROCESS.ISCRIVITIPROCESSO")}}</h2>
                            <div class="text-muted font-weight-bold font-size-h4">{{$t("REGISTERPRIVATEPROCESS.GIAACCOUNT")}}
                                <a href="/login-step1" class="text-primary font-weight-bolder">Login</a>
                            </div>
                            <form class="form mt-5">
                                <div class="form-group mb-5 text-left">
                                    <label class="checkbox m-0">
                                    <input type="checkbox" name="agree" checked/><div class="font-weight-bolder text-primary">{{$t("REGISTERPRIVATEPROCESS.ES")}}</div>
                                    <span></span></label>
                                    <div class="form-text text-muted text-center"></div>
                                </div>
                                <div class="form-group mb-5">
                                    <input class="form-control h-auto form-control-solid py-4 px-8" type="text"  v-bind:placeholder="$t('REGISTERPRIVATEPROCESS.NOME')" name="name" autocomplete="off" />
                                </div>
                                <div class="form-group mb-5">
                                    <input class="form-control h-auto form-control-solid py-4 px-8" type="text" v-bind:placeholder="$t('REGISTERPRIVATEPROCESS.NOME')" name="surname" autocomplete="off" />
                                </div>
                                <div class="form-group mb-5">
                                    <input
                                    class="form-control h-auto form-control-solid py-4 px-8"
                                    type="text"
                                    placeholder="username*"
                                    name="username"
                                    id="username"
                                    v-model="$v.form.username.$model"
                                    :state="validateState('username')"
                                    aria-describedby="username-live-feedback"
                                    />
                                </div>
                                <div class="form-group mb-5">
                                    <input class="form-control h-auto form-control-solid py-4 px-8" type="email" placeholder="Email*" name="email" autocomplete="off" />
                                </div>
                                <div class="form-group mb-5">
                                    <input class="form-control h-auto form-control-solid py-4 px-8" type="password" placeholder="Password*" name="password" />
                                </div>
                                <div class="form-group mb-5 text-left">
                                    <label class="checkbox m-0">
                                    <input type="checkbox" name="agree" />{{$t("REGISTERPRIVATEPROCESS.ACCETTO")}}
                                    <router-link to="/terms" class="font-weight-bold">{{$t("REGISTERPRIVATEPROCESS.TERMINI")}}</router-link>.
                                    <span></span></label>
                                    <div class="form-text text-muted text-center"></div>
                                </div>
                                <div class="form-group mb-5 text-left">
                                    <label class="checkbox m-0">
                                    <input type="checkbox" name="agree" />{{$t("REGISTERPRIVATEPROCESS.ACCETTOLA")}}
                                    <router-link to="/privacy" class="font-weight-bold">{{$t("REGISTERPRIVATEPROCESS.PRIVACY")}}</router-link>.
                                    <span></span></label>
                                    <div class="form-text text-muted text-center"></div>
                                </div>
                                <div class="form-group mb-5 text-left">
                                    <label class="checkbox m-0">
                                    <input type="checkbox" name="agree" />{{$t("REGISTERPRIVATEPROCESS.NEWSLETTER")}}
                                    <span></span></label>
                                    <div class="form-text text-muted text-center"></div>
                                </div>
                                <div class="form-group d-flex flex-wrap">
                                    <b-button class="btn btn-lg btn-primary text-uppercase font-weight-bolder" v-b-modal.modal-verify>{{$t("REGISTERPRIVATEPROCESS.BCONFERMA")}}</b-button>
                                    <b-button class="ml-2 btn btn-lg btn-default text-uppercase font-weight-bolder" v-b-modal.modal-login>login</b-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </b-modal>

                <b-modal id="modal-login" size="lg" centered hide-header hide-backdrop hide-footer content-class="shadow" ok-only  no-stacking>
                    <div class="row mt-10">
                        <div class="col-5 px-10">
                            <img
                                :src="(getOrganization.data) ? getOrganization.data.logo1Uri : '/assets/media/bipart/logo-bipart-brand.svg'"
                                class="h-60px"
                                alt="Logo"
                            />
                            <div class="mt-5">
                                <h1>{{$t("REGISTERPRIVATEPROCESS.TITOLO")}}</h1>
<!--                                <div class="text-muted font-weight-bold">-->
<!--                                  <p class="lead">{{$t("REGISTERPRIVATEPROCESS.SOTTOTITOLO") /* #key_loc*/}}</p>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-7 border-left px-10">
                            <h2 class="text-primary">{{$t("REGISTERPRIVATEPROCESS.ISCRIVITIPROCESSO")}}</h2>
                            <div class="text-muted font-weight-bold font-size-h4">{{$t("REGISTERPRIVATEPROCESS.NIENTEACCOUNT")}}
                                <a href="/register-step1" class="text-primary font-weight-bolder">{{$t("REGISTERPRIVATEPROCESS.REGISTRATI")}}</a>
                            </div>
                            <form class="form mt-5">
                                <div class="form-group mb-5 text-left">
                                    <label class="checkbox m-0">
                                    <input type="checkbox" name="agree" checked/><div class="font-weight-bolder text-primary">{{$t("REGISTERPRIVATEPROCESS.ES")}}</div>
                                    <span></span></label>
                                    <div class="form-text text-muted text-center"></div>
                                </div>
                                <div class="form-group mb-5">
                                    <input
                                    class="form-control h-auto form-control-solid py-4 px-8"
                                    type="text"
                                    placeholder="username/email*"
                                    name="username"
                                    id="username"
                                    v-model="$v.form.username.$model"
                                    :state="validateState('username')"
                                    aria-describedby="username-live-feedback"
                                    />
                                </div>
                                <div class="form-group mb-5">
                                    <input class="form-control h-auto form-control-solid py-4 px-8" type="password" placeholder="Password*" name="password" />
                                </div>
                                <div class="form-group d-flex flex-wrap">
                                    <b-button class="btn btn-lg btn-primary text-uppercase font-weight-bolder" v-b-modal.modal-verify>{{$t("REGISTERPRIVATEPROCESS.BCONFERMA")}}</b-button>
                                    <b-button class="ml-2 btn btn-lg btn-default text-uppercase font-weight-bolder" v-b-modal.modal-register>register</b-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </b-modal>

                <b-modal id="modal-verify" size="lg" centered hide-header hide-backdrop hide-footer content-class="shadow" ok-only no-stacking>
                    <div class="row mt-10">
                        <div class="col-5 px-10">
                            <img
                                :src="(getOrganization.data) ? getOrganization.data.logo1Uri : '/assets/media/bipart/logo-bipart-brand.svg'"
                                class="h-60px"
                                alt="Logo"
                            />
                            <div class="mt-5">
                                <h1>{{$t("REGISTERPRIVATEPROCESS.TITOLO")}}</h1>
<!--                                <div class="text-muted font-weight-bold">-->
<!--                                  <p class="lead"> {{$t("REGISTERPRIVATEPROCESS.SOTTOTITOLO") /* #key_loc*/}}</p>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-7 border-left px-10">
                            <h2 class="text-primary">{{$t("REGISTERPRIVATEPROCESS.GRAZIE")}}</h2>
                            <p class="lead"  v-html='$t("REGISTERPRIVATEPROCESS.DETTMEX")'></p>
                        </div>
                    </div>
                </b-modal>

                <b-modal id="modal-confirm" centered hide-header hide-backdrop hide-footer content-class="shadow" ok-only no-stacking>
                    <div class="text-center mt-10">
                      <img
                        :src="(getOrganization.data) ? getOrganization.data.logo1Uri : '/assets/media/bipart/logo-bipart-brand.svg'"
                        class="h-60px"
                        alt="Logo"
                      />
                      <p class="my-4 font-weight-bolder h4">{{$t("REGISTERPRIVATEPROCESS.ORGANIZATION")}}</p>
                      <h2 class="mt-10">{{$t("REGISTERPRIVATEPROCESS.ACCESSORIUSCITO")}}</h2>
                      <p>{{$t("REGISTERPRIVATEPROCESS.AUTORIZZATO")}}</p>
                      <b-button href="/assets/email/confirm-email.html" target="blank" class="mb-5">{{$t("REGISTERPRIVATEPROCESS.QUIMAIL")}}</b-button>
                    </div>
                </b-modal>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>
  .spinner.spinner-right {
    padding-right: 3.5rem !important;
  }
  </style>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import {
  LOGIN,
  // LOGOUT,
  SET_HEADER_TOKEN
} from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";
import store from "@/core/services/store";

export default {
  mixins: [validationMixin],
  name: "register-step1",
  data() {
    return {
      // errors: [],
      requireConditions: false,
      term_and_conditions: false,
      privacy:false,
      emailExists: false,
      email: '',

      // Remove this dummy login info
      form: {
        username: "",
        password: "",
      }
    };
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters([
      "getOrganization",
      "currentUser"
    ]),
    isDisabled: function(){
      return !this.privacy || !this.term_and_conditions;
    }
  },
  mounted() {
    // this.$store.dispatch(LOGOUT);
  },
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required,
        minLength: minLength(3)
      },
    },
  },
  methods: {
    validateEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    resetForm() {
      this.form = {
        username: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    onSubmitconditions() {

      if (this.email && !this.validateEmail(this.email)) {
        Swal.fire(this.$t("REGISTERPRIVATEPROCESS.TITLE2"), this.$t("REGISTERPRIVATEPROCESS.ERR4"), "info");
        return false;
      }

      // Aggiorno il profilo dell'utente con le accettazioni
      setTimeout(() => {
        let acceptData = {
          "id": this.currentUser.id,
          "termsConditionsAccepted": true,
          "privacyPolicyAccepted": true,
          "email": this.email
        }
        new Promise((resolve, reject) => {
          ApiService.put(this.$apiResource + "/users/mandatory-flags", acceptData)
          .then(() => {
            console.log('registrato');
            resolve(1);
          })
          .catch(() => {
            reject(0);
          });
        });

        // Invio l'utente alla home
        this.$router.push({ name: "intro" });
        Swal.fire(this.$t("REGISTERPRIVATEPROCESS.TITLE1"),this.$t("REGISTERPRIVATEPROCESS.ERR5") , 'info')
      }, 500);

    },

    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      let credentials = {
        username: username,
        password: password,
        // selectedOrganizationId: 1,
        selectedOrganizationDomain: this.$currentDomain,
        fetchEnabledOnly: true
      };

      // L'utente carmelo vede anche i processi disabilitati
      if (username == "carmelo") {
        // credentials.fetchEnabledOnly = false;
      }

      let loginResult = await this.$store.dispatch(LOGIN, credentials);
      submitButton.classList.remove("spinner", "spinner-light", "spinner-right");

      if ( loginResult.headers.token == "BadCredentialsException" ) {
        Swal.fire(this.$t("REGISTERPRIVATEPROCESS.TITLE2"), this.$t("REGISTERPRIVATEPROCESS.ERR1"), "info");
      } else {

        // Swal.fire('Success', 'Autenticazione riuscita', 'success')
        // this.$router.push({name: "home"});
        /* */
        const userId = jwt_decode(loginResult.headers.token).id;

        await new Promise((resolve, reject) => {
          // setTimeout( () => {
            store.dispatch(SET_HEADER_TOKEN)
            var endpoint = this.generateUrl("/users/mandatory-flags/" + userId, false);
            //generateUrl is done
            ApiService.get(this.$apiResource + endpoint)
            .then(res => {
              if (res.data.privacyPolicyAccepted && res.data.termsConditionsAccepted) {
                Swal.fire(this.$t("REGISTERPRIVATEPROCESS.TITLE1"), this.$t("REGISTERPRIVATEPROCESS.ACCESSORIUSCITO"), 'success')
                this.$router.push({name: "intro"});
              } else {
                this.emailExists = (res.data.email) ? true : false;
                this.email = res.data.email;
                this.requireConditions = true;
              }
            })
            .catch(() => {
              Swal.fire(this.$t("REGISTERPRIVATEPROCESS.TITLE3"), this.$t("REGISTERPRIVATEPROCESS.ERR3"), 'error')
              reject(0);
            });

          // }, 500);
        });
        /* */
      }
    },
  }
};
</script>
